import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer className="bg-dark text-light py-3 mt-auto">
            <Container>
                <Row className="align-items-center">
                    <Col md={6} className="text-center text-md-start">
                        <p className="mb-0">
                            © {new Date().getFullYear()} BodyIntel. All rights reserved.
                        </p>
                    </Col>
                    <Col md={6} className="text-center text-md-end">
                        <Link to="/terms" className="text-light text-decoration-none">
                            <i className="fas fa-file-contract me-1"></i>
                            Terms & Conditions
                        </Link>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;
